import * as React from 'react';
import { useContext } from 'react';
import { AddressContext } from 'constants/contexts';
import { truncate } from 'lodash-es';
import LocationIcon from '@mui/icons-material/FmdGoodOutlined';
import { Button, IconButton } from '@mui/material';

function AddressButton() {
  const { currentAddress, openModal } = useContext(AddressContext);

  if (!currentAddress) {
    return (
      <IconButton onClick={openModal}>
        <LocationIcon />
      </IconButton>
    );
  }

  return (
    <Button
      variant="text"
      sx={{ color: 'black', flexShrink: 0 }}
      onClick={openModal}
      startIcon={<LocationIcon />}
    >
      {truncate(currentAddress.label || currentAddress.text, { length: 15 })}
    </Button>
  );
}
export default AddressButton;
